import { StudyResult } from '@/shared/model';

import { isNotEmpty } from './is-empty.util';

export function hasStudyResultScanType(
  study: StudyResult,
): study is StudyResult & { scanType: string } {
  return typeof study.scanType === 'string' && isNotEmpty(study.scanType);
}
